export default __webpack_public_path__ + "static/media/chocolate-3.be78a6f1.png";